import React, { useState, useEffect, useContext } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import {
  Link,
  BrowserRouter as Router,
  useParams,
  Redirect,
} from "react-router-dom";
import axios from "axios";
import {
  CEECampaignsProvider,
  CEECampaignsContext,
} from "context/CEECampaignsContext";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import UserService from "services/UserService";
import { getCeecampaign } from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TabHeader from "components/Ui/Header/TabHeader";
import VerticalTabs from "./CEECampaign/VerticalTabs";
import MembershipsVT from "./Memberships/MembershipsVT";
import TabContext from "@mui/lab/TabContext";
import AppBar from "@mui/material/AppBar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import {
  Navigate, useLocation
} from "react-router-dom";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);


export default function SelectedCEECampaign(props) {
  const { state } = useLocation();
  if (!state) {
    return (
      <Navigate
        push
        to={{
          pathname: "/admin/cee",
        }}
      />
    )
  }
  else {
    const { ceecampaignId, ceecampaignName, ceecampaignAdminVisibility } = state;
    return (
      <CEECampaignsProvider>
        <SelectedCEECampaignChild
          ceecampaignId={ceecampaignId}
          ceecampaignName={ceecampaignName}
          ceecampaignAdminVisibility={ceecampaignAdminVisibility}
        />
      </CEECampaignsProvider>
    );
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "0 0 5px 5px",
    boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));



function SelectedCEECampaignChild({ ceecampaignId, ceecampaignName, ceecampaignAdminVisibility }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const [value, setValue] = useState("0");
  const ceeadmin = permis.includes("cee_admin");
  const classes = useStyles();
  const appContext = useContext(CEECampaignsContext);
  const { ceecampaign, setCeecampaign } = appContext;

  const { parameters } = ceecampaign;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const [isLoading, setIsLoading] = useState(true);

  const url = getCeecampaign(ceecampaignId);
  useEffect(() => {
    axios
      .get(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        if (response.data) {
          response.data.ceecampaignAdminVisibility = ceecampaignAdminVisibility;
        }
        setCeecampaign(response.data || []);
        setIsLoading(false);
      });
  }, [ceecampaignId]);

  if (ceecampaignId === "") {
    return (
      <Navigate
        push
        to={{
          pathname: "/admin/cee",
        }}
      />
    );
  }

  return (
    <GridContainer>
      <GridItem xs={12}>
        <TabHeader>
          <>
            <Link to="/admin/cee">
              <div
                style={{
                  fontSize: "13px",
                  color: "#fff",
                  opacity: "0.8",
                }}
              >
                {/* <KeyboardBackspaceIcon /> */}
                Campagnes CEE
              </div>
            </Link>
            <div
              style={{
                marginLeft: "5px",
                marginTop: "0px",
                marginBottom: "5px",
                fontSize: "15px",
                fontWeight: "bold",
              }}
            >
              / {ceecampaignName}
            </div>
          </>
        </TabHeader>
      </GridItem>

      <GridItem xs={12}>
        {!isLoading && (
          <div className={classes.demo2}>
            <TabContext value={value} className={classes.root}>
              <div className={classes.demo2}>
                <AppBar
                  position="static"
                  className={classes.demo3}
                  style={{ boxShadow: "none", shadowColor: "red" }}
                >
                  <StyledTabs
                    value={value}
                    onChange={handleChange}
                    aria-label="styled tabs example"
                    initialselectedindex={0}
                    scrollButtons="auto"
                  >
                    <StyledTab label="A propos" value={"0"} />
                    <StyledTab label="Gestion des dossiers" value={"1"} />
                  </StyledTabs>
                  <Typography className={classes.padding} />
                </AppBar>
                <Divider variant="fullWidth" />
                <TabPanel value="0">{<VerticalTabs />}</TabPanel>
                <TabPanel value="1">{<MembershipsVT />}</TabPanel>
              </div>
            </TabContext>
          </div>
        )
        }
      </GridItem>
    </GridContainer>
  );
}
